<template lang="pug">
    .card-teaser(v-if="display === 'card'" :class="{ hover: mouseover, 'no-image': hideImage }")
        router-link(
            :to="path"
            @mouseover.native="hover"
            @mouseleave.native="blur"
        )
            figure
                img(v-if="image && showImage" v-lazy="image" :title="title" )
        .rating(v-if="ratings && ratings.length")
            StarRating(
                :rating="rating"
                :increment="0.1"
                :read-only="true"
                :show-rating="false"
                :max-rating="stars"
                :star-size="16"
                :inline="true"
            )
            // .average {{ rating }}
            // .raters ({{ ratings.length }})
            .comments(v-if="comments.length")
                span {{ comments.length }}
                i.far.fa-comment
        p.topic.is-uppercase.has-text-primary.has-text-weight-bold(v-if="topic")
            | {{ topic }}
        h3.is-size-4(v-if="title" v-line-clamp:31="1")
            | {{ title }}
        .bait
            div(v-if="text" v-line-clamp:24="clamp")
                p.content(v-html="striptags(text)")
        .bottom-line
            .op
                template(v-if="op")
                    | von
                    span {{ op }}
            .link
                router-link(:to="path") mehr ...
    .row-teaser(v-else :class="{ hover: mouseover, 'no-image': hideImage }")
        .image(v-if="image")
            router-link(
                :to="path"
                @mouseover.native="hover"
                @mouseleave.native="blur"
            )
                figure
                    img(v-if="showImage" v-lazy="image" :title="title" )
        .image.placeholder(v-else)
            h5 {{ category }}
        .text
            .rating(v-if="ratings && ratings.length")
                StarRating(
                    :rating="rating"
                    :increment="0.1"
                    :read-only="true"
                    :show-rating="false"
                    :max-rating="stars"
                    :star-size="16"
                    :inline="true"
                )
                // .average {{ rating }}
                // .raters ({{ ratings.length }})
                .comments(v-if="comments.length")
                    span {{ comments.length }}
                    i.far.fa-comment
            p.topic.is-uppercase.has-text-primary.has-text-weight-bold(v-if="topic")
                | {{ topic }}
            h3.is-size-4(v-if="title" v-line-clamp:31="1")
                | {{ title }}
            .bait
                div(v-if="text" v-line-clamp:24="clamp")
                    p.content(v-html="striptags(text)")
            .bottom-line
                .op
                    template(v-if="op")
                        | von
                        span {{ op }}
                .link
                    router-link(:to="path") mehr ...
</template>

<script>

import _ from 'lodash'
import truncate from 'truncate-html'
import striptags from 'striptags'
// import { mapGetters, mapMutations, mapActions } from 'vuex'

export default {
    name: 'Teaser',
    data() {
        return {
            delay: 150,
            mouseover: false,
            showImage: true,
            stars: 5,
        }
    },
    props: {
        teaser: {
            type: Object,
            required: true,
        },
        display: {
            type: String,
            default: 'row',
        },
        hideImage: {
            type: Boolean,
            default: false,
        },
    },
    watch: {
        image() {
            // ugly workaround
            this.showImage = false
            this.$nextTick(() => {
                this.showImage = true
            })
        },
    },
    computed: {
        image() {

            let image

            if (this.teaserSection) {
                const content = this.teaserSection.contents.find(content => content.key === 'image')
                if (content && content.images.length) image = content.images[0]
            }

            if (! image && this.sections.length) {
                this.sections.forEach(section => {
                    if (image) return

                    const content = section.contents.find(content => content.key === 'image')
                    if (content && content.images.length) image = content.images[0]
                })
            }

            if (! image) return false

            const storageRoute = _.trim(`${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_PUBLIC_STORAGE_ROUTE}`, '/')

            let fit = _.get(image, 'pivot.fit') || 'fit=crop&crop=focalpoint&x=.5&y=.5&z=1'
            const parameters = {
                // ... _.get(fit.match(/x=(?<fx>[0-1]?\.?[0-9]*)/), 'groups'),
                // ... _.get(fit.match(/y=(?<fy>[0-1]?\.?[0-9]*)/), 'groups'),
                // ... _.get(fit.match(/z=(?<fz>[1-9]+\.?[0-9]*)/), 'groups'),
                ... _.get(fit.match(/w=(?<w>[0-9]+\.?[0-9]*)/), 'groups'),
                ... _.get(fit.match(/h=(?<h>[0-9]+\.?[0-9]*)/), 'groups'),
            }
            let { w, h } = parameters

            let width, height
            let aspectRatio = 16 / 9

            width = 320
            height = width / aspectRatio

            if (w && h) {
                fit = fit.replace(/w=([0-9]+\.?[0-9]*)/, `w=${width}`).replace(/h=([0-9]+\.?[0-9]*)/, `h=${height}`)
            } else if (! w && ! h) {
                fit += `&w=${width}&h=${height}`
            }

            return {
                src: `${storageRoute}/images/${image.id}/${image.name}?${fit}`,
                error: `${storageRoute}/images/${image.id}/${image.name}?${fit}&preview=greyscale`,
                loading: `${storageRoute}/images/${image.id}/${image.name}?${fit}&preview=blur`,
                width,
                height,
                aspectRatio,
            }
        },
        path() {
            const categoryKey = _.get(this.teaser, 'category.key')
            const key = this.teaser.key

            return `/${categoryKey}/${key}`
        },
        category() {
            return _.get(this.teaser, 'category.name')
        },
        topic() {
            let topic, content
            if (this.headingSection) {
                content = this.headingSection.contents.find(content => content.key === 'heading')
                topic = content.sub_title
            }

            return topic
        },
        title() {
            return _.get(this.teaser, 'title')
        },
        text() {
            let text, content
            if (this.teaserSection) {
                content = this.teaserSection.contents.find(content => content.key === 'teaser')
            }

            if (! (content && content.text) && this.descriptionSection) {
                content = this.descriptionSection.contents.find(content => content.key === 'content')
            }

            // if (this.display === 'card') {
            //     text = truncate(content.text, 18, { byWords: true })
            // } else {
            //     text = truncate(content.text, 32, { byWords: true })
            // }

            return _.get(content, 'text')
        },
        comments() {
            const comments = _.get(this.teaser, 'comments') || []
            return comments.filter(comment => comment.body && comment.body !== '')
        },
        ratings() {
            const comments = _.get(this.teaser, 'comments') || []
            const ratings = comments.filter(comment => !! comment.rating)

            return ratings
        },
        rating() {
            let rating, sum = 0
            this.ratings.forEach(el => sum += el.rating)

            const factor = sum / this.ratings.length / 100
            rating = this.stars * factor

            return parseFloat(rating.toFixed(1))
        },
        clamp() {
            let clamp = 3
            if (this.ratings && this.ratings.length) clamp = 2
            return clamp
        },
        sections() {
            return this.teaser.sections
        },
        teaserSection() {
            return this.sections.find(section => section.key === 'category-page-teaser')
        },
        descriptionSection() {
            return this.sections.find(section => section.key === 'post')
                || this.sections.find(section => section.key === 'description')
                || this.sections.find(section => section.key === 'service-description')
        },
        headingSection() {
            return this.sections.find(section => section.key === 'heading')
        },
        op() {
            let op = _.get(this.teaser, 'publisher.name')
                || _.get(this.teaser, 'evaluations[0].member.name')

            if (op) {
                const company = _.get(this.teaser, 'publisher.company')
                    || _.get(this.teaser, 'evaluations[0].member.company')

                if (company) op += ` - ${company}`
            }

            return op
        }
    },
    methods: {
        hover() {
            this.$emit('focus', this.item)
            this.mouseover = true
        },
        blur() {
            setTimeout(() => {
                this.$emit('blur', this.item)
                this.mouseover = false
            }, this.delay);
        },
        striptags(html) {
            html = html.replace(/<p[^>]*>/g, '').replace(/<\/p>/g, '<br />')
            return striptags(html, ['a', 'i', 'u', 'b', 'em', 'strong', 'span', 'br'])
        }
    },
}
</script>

<style lang="sass" scoped>

    @import "~bulma/sass/utilities/mixins";
    @import '~@/assets/sass/variables';

    .card-teaser, .row-teaser
        text-align: initial
        h3
            line-height: 1.3
            margin-bottom: 10px
        p.topic
            font-size: .85rem
            // margin-bottom: 10px
        .bait
            margin-bottom: 10px
            & > div
                word-break: normal !important
            br + br
                display: none
        .image.placeholder
            background: #D8D8D8
            border-radius: 3px
            display: flex
            justify-content: center
            align-items: center
        figure
            position: relative
            width: 100%
            padding-bottom: 56.25% // 9 / 16
            display: block
            background: #D8D8D8
            border-radius: 3px
            margin-bottom: 20px
            transition: transform .8s ease
            img
                border-radius: 3px
                position: absolute
                width: 100%
                left: 0
                top: 0
                box-shadow: $box-shadow-2
                transition: box-shadow .8s ease
        &.hover
            a figure
                transform: scale(1.04)
                img
                    box-shadow: $box-shadow-3
        .rating
            height: 20px
            margin-bottom: 15px
            font-size: 0.85rem
            display: flex
            & /deep/ .vue-star-rating-inline
                height: 20px
                .vue-star-rating-star
                    height: 20px
                .vue-star-rating-rating-text
                    margin: 0
                    margin-left: 10px
            .average
                margin-left: 10px
            .raters
                margin-left: 6px
            .comments
                flex-grow: 1
                text-align: right
                span
                    margin-right: 4px
                    font-weight: 500
                i
                    font-size: 1rem
        .bottom-line
            display: flex
            flex-direction: row
            justify-content: space-between
            .op span
                color: $primary
                margin-left: 6px
    +tablet
        .row-teaser
            display: flex
            flex-direction: row
            .image
                flex-basis: 320px
                flex-grow: 0
                flex-shrink: 0
                figure
                    margin-bottom: 0
            .text
                margin-left: 20px
                flex-grow: 1
                display: flex
                flex-direction: column
                .bait
                    flex-grow: 1

    .card-teaser, .row-teaser
        &.no-image
            .image, figure
                display: none
            .text
                margin-left: 0
</style>
